export const SET_ISLOADING = "SET_ISLOADING";
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_SHOWMETAMASKBUTTON = "SET_SHOWMETAMASKBUTTON";
export const SET_SHOWFUNDOPTION = "SET_SHOWFUNDOPTION";
export const SET_HASERROR = "SET_HASERROR";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_FAUCET = "SET_FAUCET";
export const SET_ACCOUNTS = "SET_ACCOUNTS";
